import * as React from 'react';
import { Box, Flex, IBoxProps } from '@lce/slice';

import { Price, LtoText } from '../../ui';
import { SafeImage } from '../../ui/SafeImage';
import * as Styled from './ComboBanner.style';
import BlackButton from '../../ui/BlackButton';
import { Image, Script } from '../../lib/banners/types';
import { scriptFunction } from '../../lib/util';
import WrapSymbols from '../../ui/WrapSymbols';

export interface IComboBannerProps extends IBoxProps {
  heading: string;
  script: Script;
  text?: string;
  link?: {
    url: string;
    text: string;
  };
  legal?: string;
  images: Image[];
  price: number;
  priceColor?: string;
  showButton?: boolean;
}

export const ComboBanner: React.FC<IComboBannerProps> = ({ heading, images, legal, link, price, priceColor,  script, showButton, text, ...props }) => {
  let comboImage = images[0];

  const selectImages = (images: Image[]) => {
    Object.keys(images).forEach(function(key: any) {
      if (images[key].type.toLowerCase().includes('combo')) {
        comboImage = images[key];
      }
      return;
    });
    return;
  };

  selectImages(images);

  return (
    <Styled.ComboBanner as="section" data-testid="ComboBanner" {...props}>
      <Styled.Container>
        <Styled.FlexContainer>
          <Styled.ImageWrapper flex={['initial', 'initial', '1 1 40%']}>
            <SafeImage alt={comboImage.alt} src={comboImage.url} />
          </Styled.ImageWrapper>
          <Styled.TitleContainer>
            <Flex flexDirection={['column', 'column', 'row']}>
              <Flex alignItems="center" m="0 auto">
                <Price
                  flex={['initial', 'initial', '0 1 auto']}
                  marginRight={[0, 0, 4]}
                  price={price}
                  priceColor={priceColor}
                />
              </Flex>
              <Box width={['100%', '100%', 364, 512]}>
                <LtoText
                  flex={['initial', 'initial', '2 1 auto']}
                  heading={heading}
                  script={{text:'',size:''}}
                  template={'ComboBanner'}
                  />
                <Styled.Script tilt={2} fontSize={scriptFunction(script.size, 'ComboBanner')}>
                  {script.text}
                </Styled.Script>
              </Box>
            </Flex>
            <Styled.LowerContent>
              {text && <Styled.ComboText>
                <WrapSymbols string={text} wrapper={Styled.TextSymbol} />
              </Styled.ComboText>}
              {showButton && <Box marginLeft={[0, -24]} marginTop={[24]}>
                <BlackButton href={link?.url || ''}>
                  {link?.text}
                </BlackButton>
              </Box>}
            </Styled.LowerContent>
          </Styled.TitleContainer>
        </Styled.FlexContainer>
        {legal && <Styled.Legal>{legal}</Styled.Legal>}
      </Styled.Container>
    </Styled.ComboBanner>
  );
}